import React from 'react';
import classNames from 'classnames';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useRequests } from '../../../../redux/reducer/requests';
import { useTranslation } from '../../../../translations';

const QuizComponent = React.forwardRef(function QuizComponent(
  { activeItem, currentQuiz, pause, component, reference },
  ref,
) {
  const {
    authData: { isWeb },
  } = useRequests();
  const { t } = useTranslation();
  const { Component = 'div', props = {} } = component[currentQuiz?.questions?.[activeItem]?.type] ?? {};

  return (
    <div className={`quiz ${isWeb ? '' : 'app'}`} ref={reference}>
      <div className='quiz__content'>
        <div className={'quiz__header'}>
          {t('other.questionWithValue', { value: `${activeItem + 1}/${currentQuiz?.questions?.length}` })}
        </div>
        <div className={'quiz__pagination'}>
          {currentQuiz?.questions?.map((item, index) => (
            <div
              key={`p-${index}`}
              className={classNames('quiz__pagination-item', {
                'quiz__pagination-item_active': index <= activeItem,
              })}
              style={{ flex: `0 0 ${100 / currentQuiz?.questions?.length - 1}%` }}
            />
          ))}
        </div>
        <CustomButton
          className={'button_icon button_transparent button_pause-q quiz__pause-button'}
          icon={'buttons/pause-q'}
          onClick={pause}
        />
        {!!currentQuiz?.questions?.length && (
          <SwitchTransition>
            <CSSTransition key={`quiz-item-${activeItem}`} timeout={500} classNames={'quiz__item'}>
              <Component {...props} />
            </CSSTransition>
          </SwitchTransition>
        )}
      </div>
    </div>
  );
});

export default QuizComponent;
QuizComponent.propTypes = {};
